// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"a766322e","225":"a766322e","508":"a766322e","782":"a766322e","803":"a766322e"}[chunkId] + ".chunk.css";
};